var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7e195b330004e674e1f0370f7a02366c.js').default;export default
        Object.assign({}, scope_0 )
    